<template>
  <div id="app" :view-mode="viewMode" >
    <cookie-info v-if="showCookie" @closeInfo="CloseCookieInfo"></cookie-info>
    <navbar></navbar>
    <slider v-if="hasSlider"></slider>
    <router-view v-viewer/>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import Slider from "./components/interface/Slider/Slider";
import CookieInfo from "./components/interface/CookieInfo/CookieInfo";
import { SliderConfig } from "./config/slider.config";
import { mapGetters } from "vuex";
export default {
    name: "App",
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        titleTemplate: "Marmor Kunze | %s",
        htmlAttrs: {
            lang: "de"
        },
        ,
        meta: [
            { charset: "utf-8" },
            {
                vmid: "description",
                name: "description",
                content:
                    "Mit über 50 Jahren Erfahrung in der der Natursteinverarbeitungen ist und bleibt es unser Bestreben Produkte in höchster Qualität zu fairen Preisen anzubieten."
            },
            {
                vmid: "keywords",
                name: "keywords",
                content:
                    "Naturstein, Quarzstein, Keramik, Natursteinprodukte, Natursteinverarbeitung"
            },
            {
                vmid: "viewport",
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            },
            {
                property: "og:title",
                content:
                    "Marmor Kunze - Experte für Naturstein, Quarzstein und Keramik"
            },
            { property: "og:site_name", content: "Marmor Kunze GmbH" },
            { property: "og:type", content: "website" },
            {
                property: "og:url",
                content: "https://www.marmor-kunze.de/startseite"
            },
            {
                property: "og:image",
                content:
                    "https://marmor-kunze.de/static/images/slider/naturstein-treppe.jpg"
            },
            {
                property: "og:description",
                content:
                    "Mit über 50 Jahren Erfahrung in der der Natursteinverarbeitungen ist und bleibt es unser Bestreben Produkte in höchster Qualität zu fairen Preisen anzubieten."
            }
        ],
        links: [{ rel: "canonical", href: "https://www.marmor-kunze.de/" }]
    },
    components: {
        slider: Slider,
        "cookie-info": CookieInfo
    },
    data() {
        return {
            welcome: ""
        };
    },
    computed: {
        /* sliderContent: function(){
      if(this.hasSlider){
        let content = SliderConfig.slides.find(page => page.path == this.$route.path);
        console.log(content)
      }
      //
      return sliderContent; */

        ...mapGetters({
            viewMode: "system/displayType",
            hasSlider: "slider/hasSlider",
            showCookie: "system/showCookie"
        })
    },
    methods: {
        CloseCookieInfo() {
            this.$store.commit("system/HIDE_COOKIE");
        },
        CheckForSlider() {
            let path =
                this.$route.path.charAt(this.$route.path.length - 1) == "/"
                    ? this.$route.path.slice(0, -1)
                    : this.$route.path;
            let sliderContent = SliderConfig.slides.find(
                page => page.path == path
            );
            let hasSlider = sliderContent ? true : false;
            this.$store.commit("slider/SET_SLIDER_VISIBILITY", hasSlider);
            this.$store.commit("slider/SET_SLIDER_CONTENT", sliderContent);
            this.$store.commit("slider/SET_ACTIVE_SLIDE_ID", 0);
        }
    },
    watch: {
        $route(to, from) {
            this.CheckForSlider();
            window.scrollTo(0, 0);
            this.$store.commit("system/HIDE_NAV");
        }
    },
    mounted() {
        if (this.firstVisit) {
            setTimeout(() => {
                /* this.firstVisit = false; */
            }, 20000);
        }
        this.CheckForSlider();
        let that = this;
        window.addEventListener("resize", function() {
            that.$store.commit("system/SET_WINDOW_WIDTH", window.innerWidth);
            that.$store.commit("system/SET_WINDOW_HEIGHT", window.innerHeight);
            that.$store.dispatch("system/setDisplayType", window.innerWidth);
        });
        window.addEventListener("scroll", function() {
            that.$store.commit("system/SET_Y_OFFSET", window.pageYOffset);
        });
        that.$store.commit("system/SET_WINDOW_WIDTH", window.innerWidth);
        that.$store.commit("system/SET_WINDOW_HEIGHT", window.innerHeight);
        that.$store.dispatch("system/setDisplayType", window.innerWidth);
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue